export default __webpack_public_path__ + "static/media/i134hp.24b92825.webp";